import BaseApiService from "@/api/Base";

class PublicApiService extends BaseApiService<null> {}

export default new PublicApiService({ baseURL: "/public" });
